import { jsx as _jsx } from "react/jsx-runtime";
// material-ui
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
// styles
const LoaderWrapper = styled('div')({
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1301,
    width: '100%',
});
// ==============================|| LOADER ||============================== //
const Loader = ({ isLoading }) => {
    if (!isLoading)
        return null;
    return (_jsx(LoaderWrapper, { children: _jsx(LinearProgress, { color: "primary" }) }));
};
Loader.propTypes = {
    isLoading: PropTypes.bool.isRequired,
};
export default Loader;
//# sourceMappingURL=Loader.js.map